import React, { useState, useEffect } from 'react';
import Avatar from 'react-avatar-edit';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';

const AvatarChanger = (props) => {

    const [src, setSrc] = useState(null); 
    const [sessionData, setSessionData] = useState({}); 

    const cropFn=(base64Image)=>{
        setSrc(base64Image);
    }

    const closeFn=(base64Image)=>{
        setSrc(null);
    }

    const saveAvatar=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));       
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/profilePicture`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
             },
            data: {
                profilePictureSrc: src,
            }
        };
        
        axios(options).then(response => {
            if (response.status === 200) {
                toast.success('La imagen de su perfil ha sido modificada. Para aplicar los cambios es necesario cerrar su sesión de usuario.', {
                    duration: 7000,
                    style: {
                        borderRadius: '8px',
                        background: '#333',
                        color: '#fff',
                    },
                });
            }
        });
    }


    useEffect(() => {
        setSessionData(JSON.parse(sessionStorage.getItem('sessionData')));
    }, []);

    return (
        <div className="avatarSelection"> 
            <Toaster position="bottom-right" reverseOrder={false} /> 
            <Avatar width={390} height={295} onCrop={cropFn} onClose={closeFn} exportSize={80} label="Seleccione imagen ..."/>

            {src?(
                <div className='previewProfileWrapper'>    
                    <div>
                        <span className="name">{sessionData.name} &nbsp;
                            <span className='userStatus active'>[<i className='status'></i>DISPONIBLE]</span>
                        </span>
                        <span className="profile">{sessionData.company_desc}/{sessionData.profile_desc} [{sessionData.extension}]</span>
                    </div>
                    <img src={src} alt="" className="preview"/>
                    <button className="default outline small" onClick={saveAvatar}>Aplicar</button>
                </div>
            ):null}
        </div>
    );
    
}

export default AvatarChanger;
